import { render, staticRenderFns } from "./CompGeneralGridCard.vue?vue&type=template&id=5756a5a0"
import script from "./CompGeneralGridCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralGridCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports